import type React from 'react';
import { Typography } from '@heroui/react';
import { getNodeTestIdProp } from '@/utils/nodeTestProps';

/** Which line under a name it is: the typo hint, the joined suppliers, or the catalogue match. */
type NameRowNoteKind = 'typo' | 'joined' | 'match';

type NameRowNoteProps = {
    note: NameRowNoteKind;
    children: React.ReactNode;
};

/**
 * A small muted line under a name's text (`NameRow`), wrapping inside its
 * column: "looks like a typo · …", why a cell that lists several suppliers
 * was suggested the first, or why the action control is disabled.
 */
export const NameRowNote: React.FC<NameRowNoteProps> = ({ note, children }) => (
    <Typography
        className="min-w-0 break-words"
        color="muted"
        type="body-xs"
        {...getNodeTestIdProp(`catalog-import-names-${note}`)}
    >
        {children}
    </Typography>
);
